import { render, staticRenderFns } from "./DocumentDetailTextNode.vue?vue&type=template&id=01c3cdcb&"
import script from "./DocumentDetailTextNode.vue?vue&type=script&lang=js&"
export * from "./DocumentDetailTextNode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports